/* eslint-disable no-undef */

const schoolbookSelectionPopup = () => {
  const selectButton = document.getElementById('js-select-book-button');
  const input = document.getElementById('js-schoolbook-dropdown');
  const dropdown = document.querySelector(
    '.schoolbook-search-dropdown__options'
  );
  const saveBookButton = document.getElementById('save-book-button');
  const hiddenField = document.getElementById('selected-book-id');
  const subject = selectButton.dataset.subject;
  let selectedBookTitle;
  let selectedBookId;

  if (!selectButton || !input || !dropdown || !saveBookButton || !hiddenField)
    return;

  const profileProperties = {
    profile_type: window.Sofatutor.profile?.currentProfileType(),
    profile_level: window.Sofatutor.profileLevel,
    profile_id: window.Sofatutor.profile?.currentProfileId(),
    subject: subject
  };

  const trackAmplitudeSavedSchoolbookEvent = () => {
    Sofatutor.tracking.amplitude.track(
      'schoolbook_add_pop_up_schoolbook_saved',
      {
        ...profileProperties,
        schoolbook_title: selectedBookTitle,
        schoolbook_id: selectedBookId
      }
    );
  };

  const trackAmplitudeSearchEvent = () => {
    Sofatutor.tracking.amplitude.track(
      'schoolbook_add_pop_up_search_clicked',
      profileProperties
    );
  };

  const showDropdown = () => {
    dropdown.style.display = 'block';
  };

  const hideDropdown = () => {
    dropdown.style.display = 'none';
  };

  const filterOptions = () => {
    const filter = input.value.toUpperCase();
    dropdown
      .querySelectorAll('.schoolbook-search-dropdown__option')
      .forEach(option => {
        option.style.display = option.textContent
          .trim()
          .toUpperCase()
          .includes(filter)
          ? ''
          : 'none';
      });
  };

  const selectOption = event => {
    const option = event.target.closest('.schoolbook-search-dropdown__option');
    if (!option) return;

    hiddenField.value = option.dataset.id;
    selectButton.textContent = option.textContent;
    selectedBookTitle = option.textContent;
    selectedBookId = option.dataset.id;
    saveBookButton.disabled = false;
    hideDropdown();
  };

  selectButton.addEventListener('click', showDropdown);
  selectButton.addEventListener('click', trackAmplitudeSearchEvent, {
    once: true
  });
  saveBookButton.addEventListener('click', trackAmplitudeSavedSchoolbookEvent);
  input.addEventListener('input', filterOptions);
  dropdown.addEventListener('click', selectOption);
};

$(document).on('turbolinks:before-visit', () => {
  Turbolinks.clearCache();
});

preventCachedExecution(() => {
  if (document.querySelector('.schoolbook-selection-popup')) {
    schoolbookSelectionPopup();
  }
});

document.addEventListener('turbolinks:load', function() {
  $(document).foundation();

  $('#open-schoolbook-selection-popup').on('click', function(event) {
    event.preventDefault();
    $('#schoolbook-selection-popup').foundation('open');
  });
});
